<template>
    <div class="flex fixed left-0 top-0 w-full h-full overflow-auto bg-black z-50">
      <div class="gallery-box-content m-auto flex flex-col justify-center items-center">
        <span class="text-white absolute top-3 sm:top-5 right-5 sm:right-8 font-bold text-2xl sm:text-4xl cursor-pointer transform transition hover:scale-110" @click.stop="close">&times;</span>
        <div class="h-full w-full flex">
            <div class="flex-shrink-0 flex items-center justify-center mr-4">
                <svg @click.stop="prev" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 sm:w-12 h-6 sm:h-12 text-white cursor-pointer transform transition hover:scale-110">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 9l-3 3m0 0l3 3m-3-3h7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            </div>
            <div class="flex-grow flex items-center justify-center">
                <Carousel ref="galleryBox" :items-to-show="1" :wrap-around="true" v-model="currentSlide">
                    <Slide v-for="(slide, index) in items" :key="index">
                        <div class="carousel__item text-white">
                            <img :src="getImage(slide.thumbnail)" class="max-ht-80-vh" alt="Photo">
                        </div>
                    </Slide>
                </Carousel>
            </div>
            <div class="flex-shrink-0 flex items-center justify-center ml-4">
                <svg @click.stop="next" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 sm:w-12 h-6 sm:h-12 text-white cursor-pointer transform transition hover:scale-110">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12.75 15l3-3m0 0l-3-3m3 3h-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
import { Carousel, Slide } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
export default {
    name: "gallery-box",
    components: {
        Carousel,
        Slide,
    },
    props: ["items", "selectedSlide"],
    emits: ["close"],
    data() {
        return {
            currentSlide: this.selectedSlide,
        };
    },
    methods: {
        close() {
            this.$emit('close');
        },
        getImage(url) {
            return process.env.VUE_APP_PUBLIC_URL + url;
        },
        prev() {
            this.$refs.galleryBox.prev();
        },
        next() {
            this.$refs.galleryBox.next();
        },
    }
}
</script>

<style lang="scss" scoped>
.gallery-box-content {
  width: 80%;
  height: 80%;
}
.max-ht-80-vh {
    max-height: 80vh;
}
</style>